import React from 'react';
import { Award, Users, Star, TrendingUp, CheckCircle2 } from 'lucide-react';
import { instructor } from '../data/mock';

const Instructor = () => {
  return (
    <section className="section-padding bg-black relative overflow-hidden">
      {/* Background decoration */}
      <div className="absolute top-0 right-0 w-96 h-96 bg-green-500/5 rounded-full blur-3xl"></div>

      <div className="container mx-auto px-4 relative z-10">
        <div className="max-w-6xl mx-auto">
          {/* Title */}
          <div className="text-center mb-16">
            <h2 className="text-3xl md:text-5xl font-bold text-white mb-4">
              Seu <span className="gradient-text">Instrutor</span>
            </h2>
            <p className="text-base md:text-xl text-gray-400">
              Aprenda com quem é referência nacional
            </p>
          </div>

          {/* Content */}
          <div className="grid md:grid-cols-2 gap-12 items-center">
            {/* Left: Image */}
            <div className="relative">
              {/* Floating Badge - Moved to Top */}
              <div className="absolute -top-6 -right-6 bg-yellow-500 p-6 rounded-xl shadow-2xl glow-yellow z-20">
                <div className="text-center">
                  <Star className="w-8 h-8 text-black mx-auto mb-2" />
                  <div className="text-2xl font-bold text-black">Endorsee</div>
                  <div className="text-sm text-black/80">Oficial</div>
                </div>
              </div>
              
              <div className="aspect-square glass rounded-2xl overflow-hidden relative group">
                <img 
                  src="https://customer-assets.emergentagent.com/job_behringer-school/artifacts/i92csdl6_IMG_4848.JPEG"
                  alt="Adeilson Chagas - Instrutor Oficial Behringer"
                  className="w-full h-full object-cover"
                />
                {/* Behringer Logo Bar - Bottom of Photo */}
                <div className="absolute bottom-0 left-0 right-0 bg-black/80 backdrop-blur-sm py-4 px-6 flex items-center justify-center border-t border-yellow-500/30">
                  <img 
                    src="https://customer-assets.emergentagent.com/job_behringer-school/artifacts/r5m1uacd_LOGO%20BEHRINGER%20PNG%20BRANCA.png"
                    alt="Behringer Official"
                    className="h-8 w-auto"
                  />
                </div>
              </div>
            </div>

            {/* Right: Info */}
            <div>
              <h3 className="text-3xl font-bold text-white mb-2">{instructor.name}</h3>
              <p className="text-xl text-yellow-400 mb-6">{instructor.title}</p>
              <p className="text-gray-300 mb-8 leading-relaxed">
                {instructor.description}
              </p>

              {/* Achievements */}
              <div className="space-y-3">
                {instructor.achievements.map((achievement, index) => (
                  <div key={index} className="flex items-center gap-3">
                    <CheckCircle2 className="w-5 h-5 text-green-400 flex-shrink-0" />
                    <span className="text-gray-300">{achievement}</span>
                  </div>
                ))}
              </div>

              {/* Stats */}
              <div className="grid grid-cols-3 gap-4 mt-8">
                <div className="glass p-4 rounded-lg text-center">
                  <Award className="w-8 h-8 text-yellow-400 mx-auto mb-2" />
                  <div className="text-2xl font-bold text-white">15+</div>
                  <div className="text-xs text-gray-400">Anos de<br />Experiência no Áudio</div>
                </div>
                <div className="glass p-4 rounded-lg text-center">
                  <Users className="w-8 h-8 text-yellow-400 mx-auto mb-2" />
                  <div className="text-2xl font-bold text-white">100+</div>
                  <div className="text-xs text-gray-400">Alunos<br />Capacitados</div>
                </div>
                <div className="glass p-4 rounded-lg text-center">
                  <TrendingUp className="w-8 h-8 text-yellow-400 mx-auto mb-2" />
                  <div className="text-2xl font-bold text-white">5</div>
                  <div className="text-xs text-gray-400">Eventos<br />Oficiais Behringer</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Instructor;
